export default (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(20),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  userTypeDescriptionGridItem: {
    maxWidth: 450,
    textAlign: 'center',
  },
  userDescription: {
    maxWidth: 375,
    lineHeight: 1.25,
    height: 120,
    display: 'inline-block',
  },
  userChip: {
    margin: '1rem',
    fontSize: '1rem',
    fontWeight: 500,
  },
});
